module.exports = __webpack_public_path__ + "img/SettingsSmall.f2766dff.svg";